import { createAction } from 'redux-actions';

import dynaForms from '@elab/core/utils/dynaForms';

import types, { storeName } from './types';

const setDeliveryAddressData = createAction(types.SET_DELIVERY_ADDRESS_DATA);
const setDeliveryAddressOperation = createAction(types.SET_DELIVERY_ADDRESS_OPERATION);
const resetData = createAction(types.RESET_DATA);
const setIsTimeSlotEmpty = createAction(types.SET_IS_TIME_SLOT_EMPTY);
const setFieldsErrors = createAction(types.SET_FIELDS_ERRORS);

const setDelivery = createAction(types.SET_DELIVERY_MODE);
const setDeliveryModes = createAction(types.SET_DELIVERY_MODES);

const setDeliveryTimeSlots = createAction(types.SET_DELIVERY_TIME_SLOTS);
const loadDeliveryModes = createAction(types.LOAD_DELIVERY_MODES);

export default {
    ...dynaForms.getActions(storeName),
    loadDeliveryModes,
    setDeliveryAddressOperation,
    setDeliveryAddressData,
    setDeliveryModes,
    resetData,
    setDeliveryTimeSlots,
    setDelivery,
    setIsTimeSlotEmpty,
    setFieldsErrors,
};
